(function () {
  'use strict';
  if (customElements.get('hj-message-card')) return;
  class MessageCard extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.toggle = this.querySelector('[data-card-toggle]');
      this.input = this.querySelector('[data-card-input]');
      this.fields = this.querySelector('[data-card-fields]');
      this.error = this.querySelector('[data-card-error]');
      this.dataset.productHandle ||= 'christmas-message-card';
      const art = this.querySelector('[data-card-art]');
      if (!art.contains(this.input)) art.append(this.input);
      this.scope = this.closest('.hj-personalize-scope');
      this.available = this.dataset.available === 'true' && Number(this.dataset.variantId) > 0;
      this.toggle.disabled = !this.available;
      this.toggle.addEventListener('change', () => {
        this.render();
        this.changed();
      });
      this.input.addEventListener('input', () => { this.render(); this.changed(); });
      this.render();
      if (window.ResizeObserver) {
        this.resize = new ResizeObserver(() => this.validate(false));
        this.resize.observe(this.querySelector('[data-card-art]'));
      }
    }
    disconnectedCallback() {
      if (this.resize) this.resize.disconnect();
      this.ready = false;
    }
    message() { return this.input.value.replace(/\r\n?/g, '\n'); }
    signature() { return JSON.stringify([this.toggle.checked, this.dataset.variantId, this.message()]); }
    price() { return this.toggle.checked && this.available ? Number(this.dataset.price) || 0 : 0; }
    validate(showError) {
      let error = '';
      const message = this.message();
      if (this.toggle.checked) {
        if (!this.available) error = 'This card is currently unavailable. Please uncheck it to continue.';
        else if (!message.trim()) error = 'Please enter your message for the card.';
        else if (Array.from(message).length > Number(this.dataset.maxLength || 200)) error = 'Please shorten your message to fit the card.';
        else if (message.split('\n').length > 7) error = 'Please use no more than 7 lines.';
        else {
          const text = this.input;
          if (text.clientHeight && text.scrollHeight > text.clientHeight + 1) error = 'Your message is too tall for the card. Please shorten it or remove a line break.';
        }
      }
      this.input.setCustomValidity(error);
      this.input.setAttribute('aria-invalid', error && (showError || message) ? 'true' : 'false');
      this.error.textContent = error;
      this.error.hidden = !error || (!showError && !message);
      return error;
    }
    cartItem() {
      if (!this.toggle.checked) return null;
      const error = this.validate(true);
      if (error) { this.input.focus(); throw new Error(error); }
      return { id: Number(this.dataset.variantId), quantity: 1, properties: { Message: this.message() } };
    }
    async prepareCartItem() {
      const item = this.cartItem();
      if (!item) return null;
      const signature = this.signature();
      if (!this.confirmation || this.confirmation.signature !== signature) {
        this.confirmation = { signature, key: crypto.randomUUID() };
      }
      const confirmation = this.confirmation;
      if (confirmation.item) return structuredClone(confirmation.item);
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 60000);
      try {
        const response = await fetch((this.dataset.apiOrigin || 'https://api.havjoy.com') + '/api/message-card/prepare', {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, signal: controller.signal,
          body: JSON.stringify({ product_handle: this.dataset.productHandle, variant_id: String(item.id),
            message: item.properties.Message, confirmation_key: confirmation.key, defer_render: true })
        });
        const result = await response.json();
        if (!response.ok || !result.success) throw new Error(result.error || 'Your card could not be saved. Please retry.');
        if (signature !== this.signature()) throw new Error('Your card changed while saving. Please add it again.');
        if (result.properties?.Message !== item.properties.Message || !result.properties?._message_card_session || (result.render_deferred !== true && !result.properties?._your_design)) {
          throw new Error('The saved card is incomplete. Please retry.');
        }
        confirmation.item = { ...item, properties: result.properties };
        return structuredClone(confirmation.item);
      } finally { clearTimeout(timer); }
    }
    setBusy(busy) {
      this.toggle.disabled = busy || !this.available;
      this.input.disabled = busy || !this.toggle.checked;
    }
    render() {
      this.fields.hidden = !this.toggle.checked;
      this.input.disabled = !this.toggle.checked;
      this.input.required = this.toggle.checked;
      this.querySelector('[data-card-count]').textContent = this.input.value.length + '/' + (this.dataset.maxLength || 200);
      this.validate(false);
    }
    changed() { this.dispatchEvent(new CustomEvent('havjoy:message-card-change', { bubbles: true })); }
  }
  customElements.define('hj-message-card', MessageCard);
})();
